// Extend native carousel controls for partially visible cards.
customElements.whenDefined('scroll-carousel').then(() => {
  document.querySelectorAll('.pdp-v2-slider-controls').forEach(controls => {
    const track = document.getElementById(controls.querySelector('button').getAttribute('aria-controls'));
    if (!track) return;
    const move = direction => {
      const limit = track.scrollWidth - track.clientWidth;
      const offsets = [...track.children].map((_, index) => Math.min(limit, index * track.itemOffset));
      const index = direction > 0 ? offsets.findIndex(offset => offset > track.scrollLeft + 2) : offsets.findLastIndex(offset => offset < track.scrollLeft - 2);
      if (index >= 0) track.select(index, {animate: !matchMedia('(prefers-reduced-motion: reduce)').matches, force: true});
    };
    controls.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      event.preventDefault(); event.stopImmediatePropagation();
      move(button.getAttribute('is') === 'next-button' ? 1 : -1);
    }, true);
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    });
  });
});


// Load comparison videos only near the viewport and pause off-screen motion.
class PdpFeatureVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
    this.abort = new AbortController();
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.userPaused = this.motion.matches;
    this.button.addEventListener('click', () => {
      this.userPaused = !this.video.paused;
      this.userPaused ? this.video.pause() : this.play();
    }, {signal: this.abort.signal});
    const sync = () => {
      this.button.querySelector('path').setAttribute('d', this.video.paused ? 'm8 4 12 8-12 8z' : 'M6 4h4v16H6zm8 0h4v16h-4z');
      this.button.setAttribute('aria-label', `${this.video.paused ? 'Play' : 'Pause'} ${this.dataset.title} video`);
    };
    this.video.addEventListener('play', sync, {signal: this.abort.signal});
    this.video.addEventListener('pause', sync, {signal: this.abort.signal});
    this.motion.addEventListener('change', () => {
      if (this.motion.matches) { this.userPaused = true; this.video.pause(); }
    }, {signal: this.abort.signal});
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.video.pause();
      else if (this.visible && !this.userPaused) this.play();
    }, {signal: this.abort.signal});
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      if (this.visible && !this.userPaused && !document.hidden) this.play();
      else this.video.pause();
    }, {threshold: 0.35});
    this.observer.observe(this);
    sync();
  }
  play() {
    if (!this.video.src) this.video.src = this.video.dataset.src;
    this.video.play().catch(() => {});
  }
  disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); this.video?.pause(); }
}
if (!customElements.get('pdp-feature-video')) customElements.define('pdp-feature-video', PdpFeatureVideo);
